﻿import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

const newsletterApp = {
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            dataApi: '',
            email: '',
            responseError: false,
            submitted: false
        }
    },
    validations() {
        return {
            email: { required, email }
        }
    },
    methods: {
        async submitNewsletter() {
            const valid = await this.v$.$validate();
            if (!valid) return
            const data = { email: this.email };
            const response = await this.fetchData(data);
            if (response && response.status === 200) {
                this.responseError = response.ok;
                this.submitted = true;
            } else {
                this.responseError = true;
            }
        },
        async fetchData(query) {
            try {
                const response = await axios.post(this.dataApi, query);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
    }
}

export default newsletterApp;